import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function RevenueIndInt({ chart_data }) {
  const [data, setData] = useState({});
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (!chart_data || chart_data.length === 0) return;

    // ✅ Labels (Years)
    const labels = chart_data.map((item) => item.year);

    // ✅ Convert to Cr
    const indiaData = chart_data.map((item) =>
      Number((item.india / 10000000).toFixed(2))
    );

    const internationalData = chart_data.map((item) =>
      Number((item.international / 10000000).toFixed(2))
    );

    // ✅ Dataset
    setData({
      labels,
      datasets: [
        {
          label: "India",
          data: indiaData,
          backgroundColor: "#f4c20d",
          borderRadius: 6,
        },
        {
          label: "International",
          data: internationalData,
          backgroundColor: "#c49a6c",
          borderRadius: 6,
        },
      ],
    });

    // ✅ Options (Horizontal Bar)
    setOptions({
      indexAxis: "y", // 🔥 makes it horizontal
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "top",
        },
        tooltip: {
          callbacks: {
            label: (context) =>
              `${context.dataset.label}: ₹ ${Number(context.raw).toFixed(2)} Cr`,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            callback: (value) => `₹ ${Number(value).toFixed(2)} Cr`,
          },
        },
      },
    });
  }, [chart_data]);

  return (
    <div style={{ width: "100%", height: "320px" }}>
      {data?.datasets && <Bar data={data} options={options} />}
    </div>
  );
}

export default RevenueIndInt;